export default "__VITE_ASSET__5bbca4f9__"